import { Provider } from '@angular/core';
import { ElectronService } from '@app/electron/electron.service';
import { AuthTokenAdapter } from '@shared/adapters/auth-token-adapter';
import { SharedSocketService } from '@shared/services/shared-socket.service';
import RendererSocket from 'src/adapters/renderer-socket';

import { RENDERER_AUTH_TOKEN } from './renderer-auth-token-provider';

export const SHARED_SOCKET_SERVICE_PROVIDER: Provider = {
  provide: SharedSocketService,
  useFactory: (electronService: ElectronService, authTokenAdapter: AuthTokenAdapter) => {
    const adapter = new RendererSocket(electronService, authTokenAdapter);
    return new SharedSocketService(adapter);
  },
  deps: [ElectronService, RENDERER_AUTH_TOKEN],
};
